function install(Vue) {
    const bus = new Vue()

    Object.defineProperties(Vue.prototype, {
        $bus: {
            get() {
                return bus
            },
        },
    })

    Vue.$bus = bus
}

export default {
    install,
}
